// critical Apperle theme styles
import '../../static/css/styles.css'
import '../../static/css/color/style7.css'
import './index.css'

import PropTypes from 'prop-types'
import React from 'react'

import Head from '../components/Head'
import CopyRight from '../components/CopyRight'
import Nav from '../components/Nav'
import PreLoader from '../components/PreLoader'
import logoImg from '../resources/logo-img.png'
import logoText from '../resources/logo-text.png'

const indexNav = [
  {
    title: 'Home',
    dataScrollNav: 0,
  },
  {
    title: 'Features',
    dataScrollNav: 1,
  },
  {
    title: 'Screenshots',
    dataScrollNav: 2,
  },
  {
    title: 'Demo',
    dataScrollNav: 3,
  },
  {
    title: 'Pricing',
    dataScrollNav: 5,
  },
  {
    title: 'Contact',
    dataScrollNav: 8,
  },
  {
    title: 'Blog',
    href: '/blog',
  },
]

// TODO: page transitions using router
const blogNav = [
  {
    title: 'Home',
    href: '/',
  },
  {
    title: 'Blog',
    href: '/blog',
  },
]

class TemplateWrapper extends React.Component {
  render() {
    const { children } = this.props
    const isIndex = this.isIndexRoute()
    const nav = isIndex ? indexNav : blogNav
    const logoItem = isIndex ? { dataScrollNav: 0 } : { href: '/' }
    return (
      <div>
        <Head />
        <PreLoader />
        <Nav
          logoImg={logoImg}
          titleImg={logoText}
          items={nav}
          logoItem={logoItem}
        />
        {children()}
        <CopyRight year={2018} name="Instea s.r.o." link="http://instea.co" />
      </div>
    )
  }

  isIndexRoute() {
    const { location: { pathname } } = this.props
    return pathname === '/' || pathname.startsWith('/index')
  }

  componentDidMount() {
    // init external javascript
    window.initMaterialize()
    window.initMainScript()
    window.initAnimated()
    window.initContactForm()
  }

  componentDidUpdate() {
    if (this.isIndexRoute()) {
      window.initMainScript()
      window.initContactForm()
      window.initAnimated()
    }
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper

export const pageQuery = graphql`
  fragment LatestPostsFragment on MarkdownRemarkConnection {
    edges {
      node {
        excerpt(pruneLength: 40)
        id
        frontmatter {
          title
          path
          featuredImage {
            childImageSharp {
              resolutions(width: 42, height: 42) {
                ...GatsbyImageSharpResolutions_noBase64
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js